import { render, staticRenderFns } from "./TrademarkObjectionToOpposingViewStatusForm.vue?vue&type=template&id=94c80108&"
import script from "./TrademarkObjectionToOpposingViewStatusForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToOpposingViewStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToOpposingViewStatusForm.vue?vue&type=style&index=0&id=94c80108&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports